import { LedgerModel, LedgerType } from '../utils/Models';
import { DataGrid, GridColumns, GridSortItem } from "@mui/x-data-grid";
import { DateTime } from 'luxon';
import { Colors } from '../../config/Constants';
import { LedgerCard } from './LedgerCard';

// Color map
const ledgerTypeToText: { [k in LedgerType]: string } = {
  [LedgerType.MANUAL_CREDIT]: 'Adjustment: CREDIT',
  [LedgerType.MANUAL_DEBIT]: 'Adjustment: DEBIT',
  [LedgerType.ORDER_SETTLEMENT]: 'Order Settlement',
}
const ledgerTypeToColorMap: { [k in LedgerType]: string } = {
  [LedgerType.MANUAL_CREDIT]: Colors.primary,
  [LedgerType.MANUAL_DEBIT]: Colors.failureRed,
  [LedgerType.ORDER_SETTLEMENT]: Colors.primary,
}

// Ledger grid component
export function LedgerTable(props: {
  ledger: LedgerModel[],
  setParentState: any,
  containerClass: any
}) {
  const dgProps = {
    disableColumnMenu: true,
    disableColumnFilter: true,
    className: 'gbk-dg',
    rowHeight: 50,
    pageSize: 10,
    sortModel: [{ field: 'id', sort: 'asc' }] as GridSortItem[],
    columns: [
      {
        field: 'id',
        headerName: 'ID',
        width: 100,
        renderCell: o => `#${o.value}`,
        sortable: false
      }, {
        field: 'adjustmentType',
        headerName: 'Type',
        width: 200,
        align: 'center',
        renderCell: (o: { row: LedgerModel }) => (
          <span style={{ color: ledgerTypeToColorMap[o.row.adjustmentType] }}>
            {ledgerTypeToText[o.row.adjustmentType]}
          </span>
        ),
        sortable: false
      }, {
        field: 'amount',
        headerName: 'Amount',
        width: 250,
        align: 'center',
        renderCell: (o: { row: LedgerModel }) => (
          <b>
            ₹
            {o.row.adjustment ? o.row.adjustment.value1 : ''}
            {o.row.settlement ? o.row.settlement.settlementAmount : ''}
          </b>
        ),
        sortable: false
      }, {
        field: 'initiatedOn',
        headerName: 'Initiated on',
        width: 250,
        align: 'center',
        renderCell: (o: { row: LedgerModel }) => (
          <span >
            {o.row.adjustment ? DateTime.fromMillis(Number(o.row.adjustment.startTime)).toLocaleString(DateTime.DATETIME_MED) : ''}
            {o.row.settlement ? DateTime.fromISO(o.row.settlement.initiatedOn).toLocaleString(DateTime.DATETIME_MED) : ''}
          </span>
        ),
        sortable: false
      }, {
        field: 'updatedOn',
        headerName: 'Updated on',
        width: 250,
        align: 'center',
        renderCell: (o: { row: LedgerModel }) => (
          <span >
            {o.row.adjustment ? DateTime.fromMillis(Number(o.row.adjustment.endTime)).toLocaleString(DateTime.DATETIME_MED) : ''}
            {o.row.settlement ? DateTime.fromISO(o.row.settlement.updatedOn).toLocaleString(DateTime.DATETIME_MED) : ''}
          </span>
        ),
        sortable: false
      }
    ] as GridColumns
  }

  return <div className={props.containerClass}>
    {/* PC Grid */}
    {/* <DataGrid
      sx={{ display: { xs: 'none', md: 'flex' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={dgProps.className}
      rowHeight={dgProps.rowHeight}
      rows={props.ledger || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
    /> */}
    {/* Phone Grid */}
    <DataGrid
      // sx={{ display: { xs: 'flex', md: 'none' } }}
      disableColumnMenu={dgProps.disableColumnMenu}
      disableColumnFilter={dgProps.disableColumnFilter}
      className={`${dgProps.className} phone`}
      rowHeight={183}
      rows={props.ledger || []}
      columns={dgProps.columns}
      pageSize={dgProps.pageSize}
      rowsPerPageOptions={[dgProps.pageSize]}
      disableSelectionOnClick
      disableVirtualization={true}
      headerHeight={0}
      components={{
        Row: (data: { row: LedgerModel }) => (
          <LedgerCard
            data={data.row}
          />
        )
      }}
    />
  </div >

}